<p class="mb-0">{{'ASSESSMENT_UPLOADED_PHOTO'  | translate}}</p>
<p class="mt-0">{{'ASSESSMENT_UPLOADED_PHOTO_DESC_BELOW'  | translate}}</p>
